export default __webpack_public_path__ + "static/media/Directory.5a696c69.svg";